import { useState } from "react";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";
import axios from "axios"; // TODO: feature/improve-axios-safety リリース後にaxiosのwrapper関数に置き換える

type ClientShop = {
  value: number;
  label: string;
};

export const useFetchClientShops = (
  fetchUrl: string,
  defaultShops: readonly ClientShop[],
  defaultClientShop: number | undefined,
) => {
  const [currentClientShopId, setCurrentClientShopId] = useState<number | undefined>(
    defaultClientShop,
  );
  const [clientShopOptions, setClientShopOptions] = useState<readonly ClientShop[]>(defaultShops);

  const fetchClientShops = async (workId: string | undefined) => {
    // 求人を選択していない場合、求人を自動選択している場合は店舗の選択肢を空にする
    if (!workId || workId === "auto") {
      setClientShopOptions([]);
      setCurrentClientShopId(undefined);
      return;
    }

    try {
      const { data } = await axios.get<[string, number][]>(fetchUrl, {
        params: { work_id: workId },
      });
      // [店舗名, 店舗ID] の形式でデータが返る
      setClientShopOptions(data.map((shop) => ({ label: shop[0], value: shop[1] })));

      // 現在の店舗が選択肢にない場合は、選択を解除
      if (!data.some((item) => item[1] === currentClientShopId)) {
        setCurrentClientShopId(undefined);
      }
    } catch (error) {
      sendErrorLog(error as Error);
    }
  };

  const handleClientShopChange = (value: number | undefined) => {
    setCurrentClientShopId(value);
  };

  return { currentClientShopId, clientShopOptions, fetchClientShops, handleClientShopChange };
};
